import {
  DailyRewardOpenResultDto,
  DailyRewardStateDto,
  EDailyRewardSlotStatus,
  EDailyRewardType,
} from '@skillarea/lib-shared';

export type TChestPreviewReward = 'coins' | 'empty' | 'achievement';

export function isChestPreviewEnabled(): boolean {
  if (!import.meta.env.DEV || typeof window === 'undefined') {
    return false;
  }

  return new URLSearchParams(window.location.search).has('chestPreview');
}

export function getChestPreviewReward(): TChestPreviewReward {
  if (typeof window === 'undefined') {
    return 'coins';
  }

  const value = new URLSearchParams(window.location.search).get('chestPreview');

  if (value === 'empty' || value === 'achievement' || value === 'coins') {
    return value;
  }

  return 'coins';
}

export function createChestPreviewState(): DailyRewardStateDto {
  return {
    currentDayIndex: 3,
    currentStreak: 2,
    openedToday: false,
    canOpen: true,
    maxDayIndex: 30,
    slots: [
      {
        dayIndex: 1,
        status: EDailyRewardSlotStatus.opened,
        rewardType: EDailyRewardType.coins,
        coins: 100,
      },
      {
        dayIndex: 2,
        status: EDailyRewardSlotStatus.opened,
        rewardType: EDailyRewardType.empty,
      },
      {
        dayIndex: 3,
        status: EDailyRewardSlotStatus.available,
      },
      {
        dayIndex: 4,
        status: EDailyRewardSlotStatus.locked,
      },
      {
        dayIndex: 5,
        status: EDailyRewardSlotStatus.locked,
      },
    ],
  };
}

export function createChestPreviewOpenResult(
  dayIndex: number,
  reward: TChestPreviewReward,
): DailyRewardOpenResultDto {
  if (reward === 'empty') {
    return { dayIndex, rewardType: EDailyRewardType.empty };
  }

  if (reward === 'achievement') {
    return {
      dayIndex,
      rewardType: EDailyRewardType.achievement,
      achievementId: 'login-streak-30',
    };
  }

  return {
    dayIndex,
    rewardType: EDailyRewardType.coins,
    coins: 500,
  };
}

export function applyChestPreviewOpen(
  state: DailyRewardStateDto,
  result: DailyRewardOpenResultDto,
): DailyRewardStateDto {
  return {
    ...state,
    openedToday: true,
    canOpen: false,
    slots: state.slots.map((slot) =>
      slot.dayIndex === result.dayIndex
        ? {
            ...slot,
            status: EDailyRewardSlotStatus.opened,
            rewardType: result.rewardType,
            coins: result.coins,
            achievementId: result.achievementId,
          }
        : slot,
    ),
  };
}

export async function simulateChestPreviewOpenDelay(): Promise<void> {
  await new Promise<void>((resolve) => {
    window.setTimeout(resolve, 120);
  });
}
